module.exports = __webpack_public_path__ + "static/media/Valentina Paz Headshot_1723797159692.a2c35a2d.jpeg";